export default [
  {
    path: 'login',
    name: 'MobileLogin',
    component: () => import ('@/mobile/login.vue'),
    meta: {
      title: '登录'
    }
  }
]
